/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Step_Time_15Inputs */

const en_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sec`)
};

const de_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 Sek.`)
};

const fr_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 s`)
};

const es_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 seg`)
};

const it_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 s`)
};

const nl_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sec`)
};

const pl_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sek`)
};

const fi_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sek`)
};

const da_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sek`)
};

const sv_onboarding_step_time_15 = /** @type {(inputs: Onboarding_Step_Time_15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 sek`)
};

/**
* | output |
* | --- |
* | "15 sec" |
*
* @param {Onboarding_Step_Time_15Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_step_time_15 = /** @type {((inputs?: Onboarding_Step_Time_15Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Step_Time_15Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_step_time_15(inputs)
	if (locale === "fr") return fr_onboarding_step_time_15(inputs)
	if (locale === "es") return es_onboarding_step_time_15(inputs)
	if (locale === "it") return it_onboarding_step_time_15(inputs)
	if (locale === "nl") return nl_onboarding_step_time_15(inputs)
	if (locale === "pl") return pl_onboarding_step_time_15(inputs)
	if (locale === "fi") return fi_onboarding_step_time_15(inputs)
	if (locale === "da") return da_onboarding_step_time_15(inputs)
	if (locale === "sv") return sv_onboarding_step_time_15(inputs)
	return en_onboarding_step_time_15(inputs)
});